import { SettingsAction, SettingsActionKeys } from '../actions/settings';
import { UiAction, UiActionKeys } from '../actions/ui';
import { PdfImportingStatus } from '../constants';
import { Api } from '../../../typings/api';
import Utils from '../../../utils';

export interface SettingsState {
	isDisplayed: boolean;
	fields: Api.PublicationSettings | {};
	projectUrl: string;
	pdfSettings: Api.PublicationPdfSettings | {};
	pdfImportingStatus: PdfImportingStatus | null;
	serverErrors: { [key: string]: string | null };
}

const settingsInitialState: SettingsState = {
	isDisplayed: false,
	fields: {},
	projectUrl: '',
	pdfSettings: {},
	pdfImportingStatus: null,
	serverErrors: {},
};

export const settings = (state: SettingsState = settingsInitialState, action: SettingsAction | UiAction): SettingsState => {
	switch (action.type) {
		case SettingsActionKeys.TOGGLE_SETTINGS_PANEL: {
			return {
				...state,
				isDisplayed: !state.isDisplayed,
			};
		}
		case SettingsActionKeys.SET_SETTINGS:
			return {
				...state,
				fields: {
					...state.fields,
					...action.fields,
				},
				pdfSettings: {
					...state.pdfSettings,
					...action.pdfSettings,
				},
				projectUrl: action.projectUrl || state.projectUrl,
			};
		case SettingsActionKeys.SET_SETTINGS_ERROR: {
			const newState = Utils.deepCopy(state);

			if (action.value === null) {
				delete newState.serverErrors[action.name];
			} else {
				newState.serverErrors[action.name] = action.value;
			}

			return newState;
		}
		case SettingsActionKeys.SET_PDF_IMPORTING_STATUS:
			return {
				...state,
				pdfImportingStatus: action.status,
			};
		case UiActionKeys.RESET:
			return settingsInitialState;
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/reducer/settings.ts